<template>
    <div>
        <div class="message-wrapper">
            <div class="image">
                <img :src="notification.image_url || '/default-image.svg'">
            </div>
            <div class="message">
                <a :href="notification.url" target="_blank">
                    <div class="title">
                        {{ notification.title }}
                    </div>
                </a>
                <div class="body">
                    {{ notification.body }}
                </div>
                <div class="url">
                    {{ notification.url }}
                </div>
                <div class="info">
                    <template v-if="!isScheduled">
                      <div class="sent" v-if="isSent">Verzonden</div>
                      <div class="pending" v-else-if="isPending">Wordt verwerkt</div>
                      <div class="failed" v-else-if="isCancelled">Onderbroken</div>
                      <div class="failed" v-else-if="isFailed">Mislukt</div>
                      <div class="failed" v-else >{{ notification.status }}</div>
                    </template>
                    <div class="channel" :class="{ urgent: isUrgent }">
                        {{ channels[notification.channel] }}
                    </div>
                    <div class="date">
                        {{ sent_at }}
                    </div>
                    <button class="cancel-button" @click="cancelNotification(notification.id, index)" v-if="isScheduled">Annuleer bericht</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: ['notification', 'channels', 'index'],
        computed: {
            sent_at() {
                const time = this.notification.status === 'scheduled' ? this.notification.scheduled_time : this.notification.sent_at
                return moment(time).local().format('DD-MM-YYYY H:mm')
            },
            isUrgent() {
                return this.notification.channel === 'breaking_news'
            },
            isSent() {
                return this.notification.status === 'sent'
            },
            isPending() {
                return this.notification.status === 'pending'
            },
            isCancelled() {
                return this.notification.status === 'cancelled'
            },
            isFailed() {
                return this.notification.status === 'failed'
            },
            isScheduled() {
                return this.notification.status === 'scheduled'
            },
        },
        methods: {
            cancelNotification (id, index) {
                if(confirm("Weet je zeker dat je deze notificatie wilt annuleren?")) {
                    this.$parent.cancelNotification(id, index)
                }
            }
        }
    };
</script>

<style scoped>
    .message-wrapper {
        margin: 10px 0;
        background-color: #fafafa;
        border-radius: 12px;
        border: 1px solid #efefef;
        padding: 12px;
        display: flex;
        text-decoration: none;
        color: black;
    }
    .image img {
        width: 88px;
        margin-right: 8px;
        background-color: silver;
    }
    .message {
        flex-grow: 1;
    }
    .title {
        font-weight: bold;
    }
    .body {
        font-size: 90%;
    }
    .url {
        font-size: 80%;
        color:gray;
        padding: 4px 0;
    }
    .info {
        display: flex;
        justify-content: flex-end;
        margin-top: 8px;
    }
    .info div {
        margin: 0 6px;
        font-size: 80%;
        padding: 4px;
        border-radius: 3px;
        border: 1px solid silver;
    }
    .channel, .sent {
        background-color: #d4edda;
    }
    .urgent {
        background-color: #f8d7da;
    }
    .pending {
        background-color: #ffae00;
    }
    .failed {
        background-color: #f8d7da;
    }
    .cancel-button {
        background-color: #cd1719;
        color: #fff;
        border: 0;
        padding: 4px;
        margin: 0 6px;
        font-weight: bold;
    }
    .cancel-button:hover {
        cursor: pointer;
    }
</style>
